<template>
    <div style="height: 100%;padding: 10px 20px;box-sizing: border-box" class="descriptionsForm">
        <div style="padding-bottom: 15px;">
            <el-page-header @back="close" :content="title+'协议'"></el-page-header>
        </div>
        <el-row>
            <el-form :model="upsertForm" ref="upsertForm" label-width="90px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                <el-descriptions :column="3" border :labelStyle="{'width':'110px'}" >
                    <el-descriptions-item>
                        <template slot="label">
                            <span style="color: #F56C6C;margin-right: 4px;">*</span>协议名称
                        </template>
                        <el-form-item prop="title">
                            <el-input size="mini" maxlength="255" show-word-limit  v-model="upsertForm.title" placeholder="请输入协议名称" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-descriptions-item>

                    <el-descriptions-item>
                        <template slot="label">
                            <span style="color: #F56C6C;margin-right: 4px;">*</span>适用店面
                        </template>
                        <el-form-item prop="shopName">
                            <el-select size="mini" v-model="upsertForm.shopId" multiple placeholder="请选择店面">
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            链接
                        </template>
                        <el-form-item prop="url">
                            <el-input size="mini" maxlength="255" disabled show-word-limit  v-model="config.resIp+upsertForm.url" placeholder="请输入链接" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <span style="color: #F56C6C;margin-right: 4px;">*</span>协议内容
                        </template>
                        <el-form-item prop="content">
                            <ckeditor v-model="upsertForm.content"></ckeditor>
                        </el-form-item>
                    </el-descriptions-item>
                </el-descriptions>
            </el-form>
            <div  class="dialog-footer" style="text-align: center;">
                <el-button class="large" size="mini" @click="close">取 消</el-button>
                <el-button class="large" size="mini" type="primary" v-if="title=='增加'" v-display:sysAgreement-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button class="large" size="mini" type="primary" v-else v-display:sysAgreement-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-row>
    </div>
</template>

<script>
    import axios from 'axios'
    import ckeditor from '@/components/ckeditor-normal-math/editor';
    export default {
        components:{ckeditor},
        name: "saveOrUpdateSysAgreement",
        props: ['title','id'],
        data(){
            return {
                shopList:[],
                upsertForm:{
                    id:'',
                    title:'',
                    content:'',
                    shopId:'',
                    shopName:'',
                    url:'',
                    createTime:'',
                    updateTime:''
                },
                rules: {
                      title: [
                              { required: true, message: '请输入协议名称', trigger: 'blur',transform:val=>val.trim() },
                              {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                          ],
                      content: [
                              { required: true, message: '请输入协议内容', trigger: 'blur',transform:val=>val.trim() },
                          ],
                      shopId: [
                              { required: true, message: '请输入店铺id', trigger: 'blur',transform:val=>val.trim() },
                          ],
                      shopName: [
                              { required: true, message: '请输入适用店面', trigger: 'blur',transform:val=>val.trim() },
                          ],
                      url: [
                              { message: '请输入链接', trigger: 'blur',transform:val=>val.trim() },
                          ],
                      createTime: [
                              { required: true, message: '请输入创建时间', trigger: 'blur',transform:val=>val.trim() },
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      updateTime: [
                              { required: true, message: '请输入更新时间', trigger: 'blur',transform:val=>val.trim() },
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                },
                config:config
            }
        },
        created(){
          if(this.title=='修改'){
              axios({
                  url:`${home}/sysAgreement/update/findSysAgreementById/${this.id}`,
                  method:'GET'
              }).then(res=>{
                  Object.assign(this.upsertForm,res.data);
                  if(res.data.shopId){
                      this.upsertForm.shopId = res.data.shopId.split(",");
                  }
              }).catch(error=>{

              })
          };
          this.getShopList();
        },
        mounted(){

        },
        methods:{
            getShopList(){
                axios({
                    url:`${home}/sysShopManage/findSysShopManageAllList`,
                    method:'POST',
                    data:{pager:{}}
                }).then(res=>{
                   this.shopList=res.data;
                }).catch(error=>{
                    //do something
                })
            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        this.upsertForm.shopId=this.upsertForm.shopId.toString();
                        axios({
                            url:`${home}/sysAgreement/${this.title==='增加'?'saveSysAgreement':'update/updateSysAgreement'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.title+'成功',
                                type: 'success'
                            });
                            this.$emit('closeSaveOrUpdate',true);
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            close(){
                this.$emit('closeSaveOrUpdate');
            }
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>
